import { appEnv } from "../../config/env";

export interface NeonAuthUser {
  id: string;
  email: string;
  name?: string | null;
  image?: string | null;
}

type NeonSession = { user: NeonAuthUser; session: { expiresAt: Date | string } };

// The vanilla adapter preserves EmpreitaFlow's custom login UI and avoids shipping
// the provider's optional UI component suite in the initial bundle.
const createClient = async (url: string) => {
  const { createInternalNeonAuth } = await import("@neondatabase/auth");
  return createInternalNeonAuth(url);
};
let auth: Awaited<ReturnType<typeof createClient>> | undefined;
const client = async () => {
  if (!appEnv.neonAuthUrl) throw new Error("Neon Auth is not configured for API mode.");
  auth ??= await createClient(appEnv.neonAuthUrl);
  return auth;
};

export const neonAuthClient = {
  async signIn(email: string, password: string): Promise<NeonAuthUser> {
    const instance = await client();
    const result = await instance.adapter.signIn.email({ email, password });
    if (result.error) throw new Error(result.error.message ?? "Authentication failed");
    const session = (await instance.adapter.getSession()).data as NeonSession | null;
    if (!session?.user) throw new Error("Authentication session was not created");
    return session.user;
  },
  async session(): Promise<NeonSession | null> {
    const result = await (await client()).adapter.getSession();
    return result.data as NeonSession | null;
  },
  async token(): Promise<string | null> { return (await client()).getJWTToken(); },
  async signOut(): Promise<void> { await (await client()).adapter.signOut(); },
};
